import React from "react";
import { Link } from "react-router-dom";
import { TextField, Alert, Box } from "@mui/material";
import { AuthLayout } from "../../../shared/components/layout/AuthLayout";
import SetpassIllustration from "../../../assets/illustrations/set-pass.svg";
import {
  VALIDATOR_MINLENGTH,
  VALIDATOR_REQUIRE,
  VALIDATOR_EMAIL,
} from "../../../shared/utils/validators";
import PasswordField from "../../../shared/components/ui/PasswordField";
import FormButton from "../../../shared/components/ui/FormButton";

const ResetPasswordView = ({
  resetFormState,
  resetInputHandler,
  handleTextInputChange,
  handleResetPassword,
  isEmailLocked,
  loginState,
  setLoginState,
  isActionLoading,
  textFieldStyle,
}) => {
  return (
    <AuthLayout
      title="Set New Password"
      subtitle="Create a new password for your account"
      illustration={SetpassIllustration}
    >
      {loginState.message && (
        <Alert
          severity="error"
          className="mb-2"
          onClose={() => setLoginState({ state: "reset", message: null })}
        >
          {loginState.message}
        </Alert>
      )}
      <Box component="form" onSubmit={handleResetPassword}>
        <TextField
          label="Email"
          name="email"
          type="email"
          value={resetFormState.inputs.email.value}
          onChange={(e) =>
            handleTextInputChange(e, resetInputHandler, [
              VALIDATOR_REQUIRE(),
              VALIDATOR_EMAIL(),
            ])
          }
          placeholder="Email from your reset request"
          variant="outlined"
          fullWidth
          disabled={isEmailLocked}
          required
          sx={textFieldStyle}
          focused
        />

        <PasswordField
          key="reset_password"
          label="New Password"
          name="password"
          formState={resetFormState}
          handler={resetInputHandler}
          validators={[VALIDATOR_REQUIRE(), VALIDATOR_MINLENGTH(8)]}
          handleTextInputChange={handleTextInputChange}
          placeholder="Enter new password"
          variant="outlined"
          fullWidth
          required
          sx={textFieldStyle}
          focused
        />

        <PasswordField
          key="reset_confirm_password"
          label="Confirm New Password"
          name="confirm_password"
          formState={resetFormState}
          handler={resetInputHandler}
          validators={[VALIDATOR_REQUIRE(), VALIDATOR_MINLENGTH(8)]}
          handleTextInputChange={handleTextInputChange}
          placeholder="Confirm new password"
          variant="outlined"
          fullWidth
          required
          sx={textFieldStyle}
          focused
        />

        <FormButton
          type="submit"
          variant="contained"
          fullWidth
          size="medium"
          sx={{ backgroundColor: "primary.main" }}
          loading={isActionLoading}
        >
          Update Password
        </FormButton>
      </Box>

      <div className="text-center mt-8">
        <span className="text-sm">Back to </span>
        <Link
          to="/login"
          onClick={() => setLoginState({ state: "login", message: null })}
          className="text-primary font-bold hover:underline cursor-pointer"
        >
          Login
        </Link>
      </div>
    </AuthLayout>
  );
};

export default ResetPasswordView;
